import { ChangeDetectorRef, Component, OnInit } from '@angular/core';

// reactive
import { Observable, throwError } from 'rxjs';
import { first, mergeMap, skipWhile } from 'rxjs/operators';

// services
import { NavigationService } from '../services/navigation.service';
import { ApiService } from 'src/app/services/api.service';
import { QuestionService } from '../services/question.service';
import { ComposableService } from '../services/composable.service';

// app store
import { Store } from '@ngrx/store';
import {
  AppState,
  ADD_APP_ID,
  ADD_APPLICATION_ID,
  UPDATE_AGENT,
} from '../app-reducer';  

// utilities
import { find, get } from 'lodash';
import {Router} from "@angular/router";
import { environment } from '../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from 'src/app/components/modal.component';
import { CommonService } from '../services/common.service';
import { AppConstants } from '../app.constants';

@Component({
  selector: 'demo-welcome',
  templateUrl: './demo-welcome.component.html',
  styles: []
})

export class DemoWelcomeComponent implements OnInit {

  constructor(
    private apiService: ApiService,
    private changeDetection: ChangeDetectorRef,
    private disclosure: MatDialog,
    public service: QuestionService,
    private navigationService: NavigationService,
    private store: Store<AppState>,
    private composableService: ComposableService,
    private router: Router,
    private commonService: CommonService,
    private appConstants: AppConstants
  ) {
    this.appState$ = store.select('sections');
    this.payload = window['jhConfig'].payload;
  }
  payload: any;
  appState$: Observable<any>;
  processing = false;
  startNewApp = false;
  showOpenedApps = true;
  showSubmittedApps = false;
  date = new Date();
  AgentId: string;
  AgentFirstName: string;
  AgentLastName: string;
  AgentEmailAddress: string;
  AgentPhoneNumber= '555-55-5555';
  JH_NEW_BUSINESS_FORMS_URL: string;
  JH_REFERENCE_GUIDE_URL: string;
  FAQ_URL: string;
  isMobilePhoneView = false;
  showDebugButton = false;
  isDemo = true;

  isLoggedInViaSalesHub = false;
  applicationIdPath = 'data.ApplicationId';
  appAuthIdPath = 'data.AppAuthId';
  agentInfo = 'payload.agentInfo';
  
  ngOnInit() {
    // ensures redirect on prod registers url
    // do not touch pls
    this.router.navigate(['/express/demo-welcome']);

    // reset app state
    this.composableService.resetApplication();
    this.appState$.pipe(first()).subscribe((state: any) => {
      state.isDemo = true;
      this.commonService.logAppState(state);
    });
    // grab env
    this.showDebugButton = window['jhConfig'].env !== 'production';

    // grab producer credentials from ISAM headers
    if (window['jhConfig'].ivuser !== '') {
      this.AgentId = window['jhConfig'].ivuser;
    } else {
      if (window['jhConfig'].ivuser !== '' && window['jhConfig'].env === 'production') {
        window.location.reload();
      } else {
        // DO NOT TOUCH
        // so it shows up on dev local
        this.AgentId = 'DreamFinFit';
      }
    }
    this.checkIsamProtected();

    // Get producer credentials from ISAM headers or use hard-coded values for local and dev
    this.AgentId = (window['jhConfig'].ivuser !== '') ? window['jhConfig'].ivuser : 'DreamFinFit';
    this.AgentFirstName = (window['jhConfig'].firstname !== '') ? unescape(window['jhConfig'].firstname) : 'Dream';
    this.AgentLastName = (window['jhConfig'].lastname !== '') ? unescape(window['jhConfig'].lastname) : 'FinFit';
    this.AgentEmailAddress = (window['jhConfig'].email !== '') ? window['jhConfig'].email : 'test@test.com';

    // other config values
    this.JH_NEW_BUSINESS_FORMS_URL = window['jhConfig'].JH_NEW_BUSINESS_FORMS_URL;
    this.JH_REFERENCE_GUIDE_URL = window['jhConfig'].JH_REFERENCE_GUIDE_URL;
    this.FAQ_URL = window['jhConfig'].JH_ILLUSTRATION_URL;
    console.log('FAQ_URL: ', this.FAQ_URL);
    
    if (this.AgentId != 'DreamFinFit') {
      this.isLoggedInViaSalesHub = true;
    }

    // detect mobile phone view
    if (window.screen.width <= 414) {
      this.isMobilePhoneView = true;
    }
  }
  checkIsamProtected() {
    //if lower regions, set logged in as true automatically since you cannot log in via saleshub
    if (window['jhConfig'].env !== 'staging' && window['jhConfig'].env !== 'production'){
      this.isLoggedInViaSalesHub = true;
    }
  }
  // start new application
  startDemoApplication(illustrationFlag:boolean = false) {
    this.appState$.pipe(first()).subscribe((state: any) => {
      state.isDemo = true;
      this.commonService.logAppState(state);
    });
    this.processing = true;
    if (illustrationFlag) {
      this.startNewApp = true;
    }
    this.changeDetection.detectChanges();

    // start eApp
    const data = {};

    // subscribe to application changes
    this.apiService.startDemoApplication(data).pipe(
      mergeMap((response: any) => {
        // error handling
        if (get(response, 'code') !== 200 || !get(response, this.applicationIdPath)) {
          return throwError(response);
        }

        // update store
        this.store.dispatch({
          type: ADD_APP_ID,
          payload: get(response, this.appAuthIdPath)
        });

        // update store
        this.store.dispatch({
          type: ADD_APPLICATION_ID,
          payload: get(response, this.applicationIdPath)
        });

        // update store
        this.store.dispatch({
          type: UPDATE_AGENT,
          payload: {
            agentFirstname: this.AgentFirstName,
            agentLastname: this.AgentLastName,
            agentEmail: this.AgentEmailAddress,
            agentPhoneNumber: this.AgentPhoneNumber,
          }
        });

        return this.appState$;
      }),
      first(),
      mergeMap((response: any) => {
        // Navigate to eApp
        if (illustrationFlag) {
          this.goToEapp(illustrationFlag);
          this.startNewApp = false;
          this.changeDetection.detectChanges();
        }
        
        const requestPayload = {
          appAuthId: response.appAuthId,
          AgentId: this.AgentId,
          estimateDetails: get(response, 'estimateDetails'),
          salesSource: get(response, 'salesSource '),
          payload: {
            agentPhoneNumber: this.AgentPhoneNumber,
            agentInfo: get(response, this.agentInfo) || null
          },
          agentFirstname: this.AgentFirstName,
          agentLastname: this.AgentLastName,
          agentEmail: this.AgentEmailAddress

        };

        const processAppPayload = {
          AppAuthId: response.appAuthId,
          AppId: response.appId,
          AgentId: this.AgentId,
          AgentFirstName: this.AgentFirstName,
          AgentLastName: this.AgentLastName,
          AgentEmail: this.AgentEmailAddress
        };

        this.apiService.processApplication(processAppPayload).subscribe(  res => {
          console.log(res);
        }, (error) => {
            console.log('ERROR');
            console.log(error);
            this.startNewApp = false;
            this.processing = false;
        });

        return this.apiService.saveInfo(requestPayload);
      }),
    ).subscribe((response) => {

			// trigger observable holding block submissions until application pre-processing is done
			this.navigationService.readyToSubmit(true);

    }, (errorResponse) => {
      this.navigationService.nextSectionRelative('error');
    });

    // enter eApp
    if (!illustrationFlag) {
      this.goToEapp(illustrationFlag);
    }
  }

  startWithIllustrationModal() {
    const modalRef = this.disclosure.open(ModalComponent, {
      disableClose: true,
      closeOnNavigation: true,
      data: {
        size: '',
        // Array of screens
        screens: [
          {
            show: true,
            exit_btn: true,
            content: [
              {
                type: 'title',
                content: 'Do you want to start with illustration?',
                class: this.appConstants.modalTitleBold
              },
              {
                type: 'button_group',
                buttons: [
                  {
                    type: 'button',
                    label: 'No',
                    clickFunction: 'startWithoutIllustration',
                    class: this.appConstants.buttonSecondary
                  },
                  {
                    type: 'button',
                    label: 'Yes',
                    clickFunction: 'startWithIllustration',
                    class: this.appConstants.buttonPrimary
                  }
                ]
              }
            ]
          }
        ]
      }
    });

    modalRef.afterClosed().pipe(first()).subscribe(result => {
    if (result.event == "startWithIllustration") {

      this.startDemoApplication(true);

     } else if (result.event == "startWithoutIllustration") {
       this.startDemoApplication(false);
     } 
    })
  }

  // start new application
  startNewApplication() {​​​​
    this.processing = true;

    // start eApp
    const data = {​​​​}​​​​;
    
    this.appState$.pipe(first()).subscribe((state: any) => {​​​​
      if (state.isDemo) {​​​​
        // subscribe to application changes
        this.apiService.startDemoApplication(data)
    .pipe(
      mergeMap((response: any) => {​​​​
        // error handling
        if (get(response, 'code') !== 200 || !get(response, this.applicationIdPath)) {​​​​
          return throwError(response);
        }​​​​

        // update store
        this.store.dispatch({​​​​
          type: ADD_APP_ID,
          payload: get(response, this.appAuthIdPath)
        }​​​​);

        // update store
        this.store.dispatch({​​​​
          type: ADD_APPLICATION_ID,
          payload: get(response, this.applicationIdPath)
        }​​​​);

        // update store
        this.store.dispatch({​​​​
          type: UPDATE_AGENT,
          payload: {​​​​
            agentFirstname: this.AgentFirstName,
            agentLastname: this.AgentLastName,
            agentEmail: this.AgentEmailAddress,
            agentPhoneNumber: this.AgentPhoneNumber,
          }​​​​
        }​​​​);

        return this.appState$;
      }​​​​),
      first(),
      mergeMap((response: any) => {​​​​
        const requestPayload = {​​​​
          appAuthId: response.appAuthId,
          AgentId: this.AgentId,
          estimateDetails: get(response, 'estimateDetails'),
          salesSource: get(response, 'salesSource '),
          payload: {​​​​
            agentInfo: get(response, this.agentInfo) || null
          }​​​​,
          agentFirstname: this.AgentFirstName,
          agentLastname: this.AgentLastName,
          agentEmail: this.AgentEmailAddress
        }​​​​;

        const processAppPayload = {​​​​
          AppAuthId: response.appAuthId,
          AppId: response.appId,
          AgentId: this.AgentId,
          AgentFirstName: this.AgentFirstName,
          AgentLastName: this.AgentLastName,
          AgentEmail: this.AgentEmailAddress
        }​​​​;

        this.apiService.processApplication(processAppPayload).subscribe(  res => {​​​​
          console.log(res);
        }​​​​);

        return this.apiService.saveInfo(requestPayload);
      }​​​​),
    ).subscribe((response) => {

			// trigger observable holding block submissions until application pre-processing is done
			this.navigationService.readyToSubmit(true);​​​​

    }​​​​, (errorResponse) => {​​​​
      this.navigationService.nextSectionRelative('error');
    }​​​​);
    }​​​​ else {​​​​
        // subscribe to application changes
        this.apiService.startApplication(data)
    .pipe(
      mergeMap((response: any) => {​​​​
        // error handling
        if (get(response, 'code') !== 200 || !get(response, this.applicationIdPath)) {​​​​
          return throwError(response);
        }​​​​

        // update store
        this.store.dispatch({​​​​
          type: ADD_APP_ID,
          payload: get(response, this.appAuthIdPath)
        }​​​​);

        // update store
        this.store.dispatch({​​​​
          type: ADD_APPLICATION_ID,
          payload: get(response, this.applicationIdPath)
        }​​​​);

        // update store
        this.store.dispatch({​​​​
          type: UPDATE_AGENT,
          payload: {​​​​
            agentFirstname: this.AgentFirstName,
            agentLastname: this.AgentLastName,
            agentEmail: this.AgentEmailAddress,
            agentPhoneNumber: this.AgentPhoneNumber,
          }​​​​
        }​​​​);

        return this.appState$;
      }​​​​),
      first(),
      mergeMap((response: any) => {​​​​
        const requestPayload = {​​​​
          appAuthId: response.appAuthId,
          AgentId: this.AgentId,
          estimateDetails: get(response, 'estimateDetails'),
          salesSource: get(response, 'salesSource '),
          payload: {​​​​
            agentInfo: get(response, this.agentInfo) || null
          }​​​​,
          agentFirstname: this.AgentFirstName,
          agentLastname: this.AgentLastName,
          agentEmail: this.AgentEmailAddress
        }​​​​;

        const processAppPayload = {​​​​
          AppAuthId: response.appAuthId,
          AppId: response.appId,
          AgentId: this.AgentId,
          AgentFirstName: this.AgentFirstName,
          AgentLastName: this.AgentLastName,
          AgentEmail: this.AgentEmailAddress
        }​​​​;

        this.apiService.processApplication(processAppPayload).subscribe(  res => {​​​​
          console.log(res);
        }​​​​);

        return this.apiService.saveInfo(requestPayload);
      }​​​​),
    ).subscribe((response) => {

			// trigger observable holding block submissions until application pre-processing is done
			this.navigationService.readyToSubmit(true);​​​​

    }​​​​, (errorResponse) => {​​​​
      this.navigationService.nextSectionRelative('error');
    }​​​​);

      }​​​​
    }​​​​);

    this.goToEapp();
  }​​​​

  goToEapp(illustrationFlag:boolean = false) {
    // go to next section
    this.appState$.pipe(
      // tslint:disable-next-line:indent
      skipWhile((state: any) => {
        return (state.formData === null) || (state.questions === null);
      }),
      first()
    ).subscribe((state) => {
			if (state.questions) {
			  const routes = this.router.config;
			  const newRoutes = routes.map(item => {
          const { data } = item;
          if (data && data.blockHeading && data.blockName && data.blockName !== 'intake' && data.hasOwnProperty('isProgressRoute')) {
            const questionBlocks = find(state.questions, { Name: data.blockName });
            item.data.blockCategory = questionBlocks.BlockCategory || null;
            item.data.blockHeading = questionBlocks.DisplayName || null;
          }
          return item;
			  });
        this.navigationService.buildNavStore(newRoutes);
			};
      if (illustrationFlag) {
        this.navigationService.nextSectionRelative('illustration-start');
      } else {
        this.navigationService.nextSectionRelative('proposed-insured');
      }
      
    });
  }

  goToMiniPortal(): void {
    this.appState$.pipe(first()).subscribe((state: any) => {
      state.isDemo = false;
      this.commonService.logAppState(state);
    });
    // determine which section
    console.log('Going to mini portal!');
    this.navigationService.nextSectionRelative('financial-professional');
  }

  goToDebug(): void {
    // determine which section
    console.log('Going to debug page!');
    this.navigationService.nextSectionRelative('');
  }

  goToDemoApp(): void {
    this.appState$.pipe(first()).subscribe((state: any) => {
      state.isDemo = true;
      this.commonService.logAppState(state);
    });
    
    //console.log('Going to Demo app!');
    this.navigationService.nextSectionRelative('financial-professional');
  }
}
